import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setPreload } from "../../server/CartsOpen";
import Input from "../containers/InputForm";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    Name: yup
      .string()
      .required("חובה להכניס שם")
      .matches(/^[\u0590-\u05FFa-zA-Z\s]+$/, "שם חייב להכיל אותיות בלבד"),
    StreetName: yup
      .string()
      .required("חובה להכניס שם רחוב")
      .matches(/^[\u0590-\u05FFa-zA-Z0-9\s]+$/, "שם רחוב לא תקין"),
    City: yup
      .string()
      .required("חובה להכניס עיר")
      .matches(/^[\u0590-\u05FFa-zA-Z\s]+$/, "עיר לא תקינה"),
    StreetNumber: yup
      .string()
      .required("חובה להכניס מס' בניין")
      .matches(/^\d+$/, "מספר בניין חייב להכיל ספרות בלבד"),
    HouseNumber: yup
      .string()
      .required("חובה להכניס מס' דירה")
      .matches(/^\d+$/, "מספר דירה חייב להכיל ספרות בלבד"),
    Floor: yup
      .string()
      .required("חובה להכניס קומה")
      .matches(/^-?\d+$/, "קומה חייבת להכיל ספרות בלבד"),
    ZipCode: yup.string().matches(/^\d*$/, "מיקוד חייב להכיל ספרות בלבד"),
  })
  .required();

const NewAddress = ({ pushAddress, setNewAddress, closeSignUpPopup, user }) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      Name: user?.name || "",
      StreetName: user?.streetName || "",
      City: user?.city || "",
      StreetNumber: user?.houseNumber || "",
      HouseNumber: user?.apartment || "",
      Floor: user?.addrFloor || "",
      ZipCode: user?.zipCode || "",
    },
  });

  const [_checkBox, _setCheckBox] = useState(true);

  const saveAddress = async (data) => {
    dispatch(setPreload(true));

    const addressToUpdate = {
      city: data.City,
      streetName: data.StreetName,
      houseNumber: data.StreetNumber,
      apartment: data.HouseNumber,
      zipCode: data.ZipCode,
      name: data.Name,
      floor: data.Floor,
    };

    try {
      await pushAddress(addressToUpdate);
      if (typeof closeSignUpPopup === "function") {
        closeSignUpPopup();
      } else if (typeof setNewAddress === "function") {
        setNewAddress(false);
      }
    } catch (e) {
      console.error("Error saving address:", e);
    } finally {
      dispatch(setPreload(false));
    }
  };

  return (
    <div className="add-address">
      <form
        className="register add-address__form"
        onSubmit={handleSubmit(saveAddress)}
      >
        <span className="note">שדות חובה מסומנים ב*</span>
        <div className="add-address__row add-address__row--2">
          <div className="add-address__cell">
            <Input
              type="text"
              register={register}
              label="רחוב*"
              errors={errors}
              name="StreetName"
              className="hz-field--borderless"
            />
          </div>
          <div className="add-address__cell">
            <Input
              type="text"
              register={register}
              label="עיר*"
              errors={errors}
              name="City"
              className="hz-field--borderless"
            />
          </div>
        </div>

        <div className="add-address__row">
          <div className="add-address__cell">
            <Input
              type="text"
              register={register}
              label="שם מקבל ההזמנה"
              placeholder="שם משפחה/שם משרד/שם חברה/שם מוסד"
              errors={errors}
              name="Name"
              className="hz-field--borderless"
            />
          </div>
        </div>

        <div className="add-address__row add-address__row--3">
          <div className="add-address__cell">
            <Input
              type="tel"
              register={register}
              label="מס' בניין*"
              errors={errors}
              name="StreetNumber"
              className="hz-field--borderless"
            />
          </div>
          <div className="add-address__cell">
            <Input
              type="number"
              register={register}
              label="קומה*"
              errors={errors}
              name="Floor"
              className="hz-field--borderless"
            />
          </div>
          <div className="add-address__cell">
            <Input
              type="tel"
              register={register}
              label="מס' דירה*"
              errors={errors}
              name="HouseNumber"
              className="hz-field--borderless"
            />
          </div>
        </div>

        <div className="add-address__row">
          <div className="add-address__cell add-address__cell--zip">
            <Input
              type="tel"
              register={register}
              label="מיקוד"
              errors={errors}
              name="ZipCode"
              className="hz-field--borderless"
            />
          </div>
        </div>
        <span className="checkbox-and-btn">
          <button className="btn" type="submit">
            {"שמור > "}
          </button>
        </span>
      </form>
    </div>
  );
};

export default NewAddress;
